import moment from 'moment';

const isEmpty = (str) => str !== 0 && !str;

const minAge = 16;
const maxAge = 110;

const validateAge = (timeStamp) => {
  const age = moment().diff(moment(timeStamp), 'years');
  return age >= minAge && age <= maxAge;
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email && re.test(String(email).toLowerCase());
};

const validateNumber = (str) => isEmpty(str) || !Number.isNaN(Number(str));

const validateMoney = (str) => {
  if (isEmpty(str)) return true;
  
  // Remove any currency symbols, commas, and spaces
  const cleanValue = String(str).replace(/[£$, a0\s]/g, '');
  
  // Check if it's a valid number
  const numValue = Number(cleanValue);
  if (Number.isNaN(numValue)) {
    return false;
  }
  
  // Check if it's positive (money values should be positive)
  if (numValue < 0) {
    return false;
  }
  
  // Check if it's a reasonable amount (not too large)
  if (numValue > 999999999) {
    return false;
  }
  
  return true;
};

const validateYear = (str) => isEmpty(str) || (str.length === 4 && validateNumber(str));

const validateBirthYear = (str) =>
  isEmpty(str) || (str.length === 4 && validateNumber(str) && moment().year() >= Number(str));

const dateOlderThan16 = (date) =>
  moment().subtract(minAge, 'year') > moment(date, 'DD/MM/YYYY', true);

const dateLessThan110 = (date) =>
  moment().subtract(maxAge, 'year') <= moment(date, 'DD/MM/YYYY', true);

const validateDateOfBirth = (date) => {
  if (date === '') {
    return false;
  }
  return dateOlderThan16(date) && dateLessThan110(date);
};

const validateValue = (value) => isEmpty(value);

const getInvalidDateReasonText = (date) => {
  // Parse as DD/MM/YYYY strictly
  const mDate = moment(date, 'DD/MM/YYYY', true);

  if (!mDate.isValid()) {
    return 'A date of birth is required';
  }
  if (!dateOlderThan16(date)) {
    return `Age can't be less than ${minAge}`;
  }
  if (!dateLessThan110(date)) {
    return `Age can't be more than ${maxAge}`;
  }
  return '';
};

const getMoneyValidationMessage = (str) => {
  if (isEmpty(str)) return '';
  
  const cleanValue = String(str).replace(/[£$, a0\s]/g, '');
  const numValue = Number(cleanValue);
  
  if (Number.isNaN(numValue)) {
    return 'Please enter a valid number';
  }
  
  if (numValue < 0) {
    return 'Value cannot be negative';
  }
  
  if (numValue > 999999999) {
    return 'Value is too large';
  }
  
  return '';
};

export {
  validateValue,
  validateAge,
  validateEmail,
  validateNumber,
  validateMoney,
  validateYear,
  validateBirthYear,
  validateDateOfBirth,
  getInvalidDateReasonText,
  getMoneyValidationMessage,
  dateOlderThan16,
  dateLessThan110,
};
